module.exports = __webpack_public_path__ + "img/DAVID_CANNON_22-rs.4dd2cb83.jpg";